import { usePostHog as usePosthog } from 'posthog-js/react';

export const useEvents = () => {
  const posthog = usePosthog();

  const trackPageview = () => {
    try {
      // Google Analytics already handles SPA page views, so we only need to
      //   account for PostHog here
      //
      posthog.capture('$pageview');
    } catch (error) {
      console.error('Error tracking pageview', error);
    }
  };

  return { trackPageview };
};
